import React from 'react';
import { Col, Row } from 'tdesign-react';
import styled from 'styled-components';
import { isEmpty } from 'lodash';
import DescriptionItem from '../DescriptionItem';
import Panel from './Panel';

/**
 *
 * @param {Object} props
 * @param {string} [props.title] 标题
 * @param {*} [props.tip] 提示
 * @param {Object} [props.titleStyle] 标题样式覆盖
 * @param {*} [props.actions] 操作区
 * @param {*} props.emptySuffix 空值后缀
 * @param {number} [props.column] 列数,默认3列
 * @param {boolean} [props.bordered] 是否边框
 * @returns
 */
function Descriptions({
  column = 3,
  title,
  tip,
  titleStyle,
  children,
  actions,
  bordered,
  emptySuffix,
  ...others
}) {
  // 每列宽度
  const rowSpan = 12 / column;
  // 非空子节点
  const noEmptyChilds = React.Children.toArray(children).filter((child) => !isEmpty(child));

  return (
    <Panel
      title={title}
      bordered={bordered}
      tip={tip}
      actions={actions}
      titleStyle={titleStyle}
      {...others}
    >
      <Row align='top'>
        {noEmptyChilds.map((child, index) => {
          const colLength = noEmptyChilds.length; // 总数

          let _span = rowSpan;
          if (index + 1 === colLength) {
            // 最后一个节点
            // 当前所在列
            const currentCol = (index + 1) % column || column;
            // 最后节点的长度
            _span = (column - currentCol + 1) * rowSpan;
          }
          // 如果设置了span
          if (child.props.span) {
            _span = rowSpan * child.props.span;
          }

          return (
            <Line span={_span} key={index}>
              {React.cloneElement(child, {
                emptySuffix,
              })}
            </Line>
          );
        })}
      </Row>
    </Panel>
  );
}

Descriptions.Item = DescriptionItem;
Descriptions.Panel = Panel;

export default Descriptions;

const Line = styled(Col)`
  display: flex;
  padding: 5px 0;
  align-items: center;
`;
